import React, { useState } from 'react';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

export const GoogleButton = ({ mode = 'login', disabled = false, testid = 'google-sign-in' }) => {
  const { api } = useAuth();
  const [busy, setBusy] = useState(false);
  const begin = async () => {
    setBusy(true);
    try {
      const { data } = await api.post('/auth/google/start', { mode });
      // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
      const redirectUrl = `${window.location.origin}/dashboard?google_state=${encodeURIComponent(data.state)}`;
      const authUrl = new URL(process.env.REACT_APP_GOOGLE_AUTH_URL);
      authUrl.searchParams.set('redirect', redirectUrl);
      window.location.assign(authUrl.toString());
    } catch (e) { toast.error(typeof e.response?.data?.detail === 'string' ? e.response.data.detail : 'No se pudo abrir Google. Inténtalo otra vez.'); setBusy(false); }
  };
  return <button type="button" data-testid={testid} disabled={busy || disabled} onClick={begin} className="flex min-h-[44px] w-full items-center justify-center gap-3 rounded-lg border border-slate-300 bg-white px-4 py-3 text-sm font-semibold text-slate-800 transition-colors hover:bg-slate-100 disabled:opacity-60">{busy ? <Loader2 size={18} className="animate-spin" /> : <span aria-hidden="true" className="text-lg font-bold text-blue-600">G</span>}{mode === 'link' ? 'Vincular mi cuenta de Google' : 'Continuar con Google'}</button>;
};